exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.build-status .content[data-v-0b754fd0] {\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 16px;\n}\n.build-status .info-block.emphasize .value[data-v-0b754fd0] {\n  font-weight: bold;\n}\n.build-status .info-block.emphasize.errors .value[data-v-0b754fd0] {\n  color: #e83030 !important;\n}\n.build-status .info-block.emphasize.warnings .value[data-v-0b754fd0] {\n  color: #ea6e00 !important;\n}\n", ""]);

// exports
